// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2BBIq","title":"ClientInsurance_title__2uPjp","itemText":"ClientInsurance_itemText__103UU"};